import type React from 'react';
import { useCallback, useEffect, useState } from 'react';

export function useWidth(ref: React.RefObject<HTMLDivElement>) {
  const [width, setWidth] = useState<number | null>(null);

  const updateWidth = useCallback(() => {
    if (ref && ref.current) {
      setWidth(ref.current.getBoundingClientRect().width);
    }
  }, [ref]);

  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, [updateWidth]);

  return width;
}
